var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgAdres(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 80.6663V36.5747L32.9999 25.6663V32.9997L51.3333 25.6663V36.6663H80.6666V80.6663H7.33325ZM14.6666 73.333H73.3333V43.9997H43.9999V36.483L25.6666 43.8163V36.6663L14.6666 41.5247V73.333ZM40.3333 65.9997H47.6666V51.333H40.3333V65.9997ZM25.6666 65.9997H32.9999V51.333H25.6666V65.9997ZM54.9999 65.9997H62.3333V51.333H54.9999V65.9997ZM80.6666 36.6663H62.3333L65.9999 7.33301H76.9999L80.6666 36.6663Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdres);
export default __webpack_public_path__ + "static/media/adres.d7e589f62b0e13ca66b2258e5ca31d97.svg";
export { ForwardRef as ReactComponent };